import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import FormSectionHeader from '../common/FormSectionHeader';
import Select from '@StyledSelect';
import CustomTextField from '../../common/CustomTextField';
import ExceptionDetails from './ExceptionDetails';
import Collapse from '@material-ui/core/Collapse';
import appConstants from '../../../../../../../appConstants';

const styles = (theme) => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 8
  },
  fullWidth: {
    width: '100%'
  }
});

const ReturnDetails = ({
  classes,
  editInfo,
  errorInfo,
  onChange,
  isReturnDelivery,
  shipmentPieces,
  DispatchStore,
  isDEDelivery
}) => {
  const returnCode = editInfo.returnCode;
  const isReturnCodeException =
    returnCode && DispatchStore.getReturnDetails(returnCode)?.isException;
  const shouldShowExceptionDetails = isReturnCodeException || isDEDelivery;

  if (!isReturnDelivery && !isDEDelivery) {
    return null;
  }

  return (
    <React.Fragment>
      {isReturnDelivery && (
        <>
          <FormSectionHeader label="Return Details" uppercase />
          <div className={classes.flexRow}>
            <Select
              textFieldProps={{
                id: 'returnCode',
                label: 'Select Return Code',
                variant: 'outlined',
                helperText: errorInfo.returnCode
              }}
              value={editInfo.returnCode}
              error={Boolean(errorInfo.returnCode)}
              onChange={onChange('returnCode')}
              data={DispatchStore.returnCodes}
            />
          </div>
        </>
      )}
      <Collapse in={shouldShowExceptionDetails} timeout="auto" unmountOnExit>
        <ExceptionDetails
          editInfo={editInfo}
          errorInfo={errorInfo}
          onChange={onChange}
          isDeliveryException={isDEDelivery}
          shipmentPieces={shipmentPieces || 0} // Not required for global return: DELIVERY_SHORT warning only applies to DE (delivery exception), not return codes
        />
      </Collapse>
      {appConstants.SPECIAL_RETURNS.includes(returnCode) && (
        <CustomTextField
          id="customerName"
          label="Customer (First and Last) Name"
          handleChange={onChange('customerName')}
          error={errorInfo.customerName}
          value={editInfo.customerName ?? ''}
          className={classes.fullWidth}
        />
      )}
    </React.Fragment>
  );
};

export default compose(withStyles(styles), inject('DispatchStore'), observer)(ReturnDetails);
